import { combineReducers } from '@reduxjs/toolkit';
import userListFiltersReducer from './slices/userListFiltersSlice';

const rootReducer = combineReducers({
    userListFilters: userListFiltersReducer,
});

export default rootReducer;

